export default {
  TITLE: `Time Off requests`,
  SUMMARY: ``,
  DATES: `Dates`,
  VACATIONTYPE: `Type`,
  TIME_OFFS_THIS_YEAR: `{{name}} has requested {{count}} time off in {{year}}.`,
  TIME_OFFS_THIS_YEAR_other: `{{name}} has requested {{count}} time offs in {{year}}.`
}
